// extracted by mini-css-extract-plugin
export default {"container":"AuthStatus_container__I4CKb","name":"AuthStatus_name__NBRN1","link":"AuthStatus_link__spcRR","error":"AuthStatus_error__FwMIo"};